import { render, staticRenderFns } from "./DialogSaleTax.vue?vue&type=template&id=0feb0caa"
import script from "./DialogSaleTax.vue?vue&type=script&lang=js"
export * from "./DialogSaleTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports